// Mock user progress data for Peter
export const userData = {
  id: 'user_peter',
  name: 'Peter',
  avatar: '👨‍🎓',
  level: 12,
  xp: 2340,
  streak: 7,
  totalStudyTime: 4500, // in minutes
  joinDate: '2024-01-15',
  preferences: {
    language: 'traditional', // traditional, simplified, english
    studyLanguage: 'english', // What language to study
    displayLanguage: 'traditional', // What language to display UI in
    studyDirection: 'zh_to_en', // zh_to_en, en_to_zh
    voiceAccent: 'american',
    studyReminder: true,
    reminderTime: '19:00'
  }
};

export const userProgress = {
  vocabulary: {
    business: {
      learned: 25,
      total: 50,
      mastered: 15,
      studying: 10,
      lastStudied: '2024-01-20'
    },
    daily: {
      learned: 40,
      total: 60,
      mastered: 30,
      studying: 10,
      lastStudied: '2024-01-21'
    },
    travel: {
      learned: 15,
      total: 40,
      mastered: 8,
      studying: 7,
      lastStudied: '2024-01-19'
    },
    food: {
      learned: 20,
      total: 35,
      mastered: 12,
      studying: 8,
      lastStudied: '2024-01-20'
    },
    technology: {
      learned: 10,
      total: 30,
      mastered: 5,
      studying: 5,
      lastStudied: '2024-01-18'
    }
  },
  grammar: {
    present_tense: {
      completed: true,
      score: 85,
      attempts: 3,
      lastAttempt: '2024-01-20',
      timeSpent: 120 // minutes
    },
    past_tense: {
      completed: true,
      score: 78,
      attempts: 2,
      lastAttempt: '2024-01-19',
      timeSpent: 95
    },
    future_tense: {
      completed: false,
      score: 0,
      attempts: 0,
      lastAttempt: null,
      timeSpent: 0
    },
    conditionals: {
      completed: false,
      score: 0,
      attempts: 0,
      lastAttempt: null,
      timeSpent: 0
    },
    passive_voice: {
      completed: false,
      score: 0,
      attempts: 0,
      lastAttempt: null,
      timeSpent: 0
    }
  },
  dailyChallenges: {
    completed: [
      {
        id: 'challenge_001',
        date: '2024-01-21',
        score: 90,
        xpEarned: 50,
        timeSpent: 240
      },
      {
        id: 'challenge_002',
        date: '2024-01-20',
        score: 85,
        xpEarned: 75,
        timeSpent: 480
      }
    ],
    current: {
      id: 'challenge_003',
      startedAt: '2024-01-21T10:30:00Z',
      progress: 60 // percentage
    }
  },
  achievements: [
    {
      id: 'first_lesson',
      name: '初學者',
      nameSimplified: '初学者',
      nameEnglish: 'Beginner',
      description: '完成第一堂課',
      descriptionSimplified: '完成第一堂课',
      descriptionEnglish: 'Complete first lesson',
      icon: '🎯',
      unlockedAt: '2024-01-15',
      xpReward: 25
    },
    {
      id: 'streak_week',
      name: '連擊達人',
      nameSimplified: '连击达人',
      nameEnglish: 'Streak Master',
      description: '連續學習7天',
      descriptionSimplified: '连续学习7天',
      descriptionEnglish: 'Study for 7 consecutive days',
      icon: '🔥',
      unlockedAt: '2024-01-21',
      xpReward: 100
    },
    {
      id: 'pronunciation_expert',
      name: '發音專家',
      nameSimplified: '发音专家',
      nameEnglish: 'Pronunciation Expert',
      description: '發音準確度達95%',
      descriptionSimplified: '发音准确度达95%',
      descriptionEnglish: 'Achieve 95% pronunciation accuracy',
      icon: '🎤',
      unlockedAt: '2024-01-20',
      xpReward: 150
    }
  ],
  statistics: {
    totalWordsLearned: 110,
    totalLessonsCompleted: 15,
    totalTestsPassed: 8,
    averageScore: 82,
    favoriteCategory: 'daily',
    studyStreak: 7,
    longestStreak: 12,
    weeklyGoal: 300, // minutes
    weeklyProgress: 180 // minutes this week
  }
};

export const leaderboard = [
  { rank: 1, name: 'Alice Chen', xp: 4520, avatar: '👩', country: '🇹🇼', isUser: false },
  { rank: 2, name: 'David Kim', xp: 4350, avatar: '👨', country: '🇰🇷', isUser: false },
  { rank: 3, name: 'Maria Silva', xp: 4200, avatar: '👩', country: '🇧🇷', isUser: false },
  { rank: 4, name: 'John Smith', xp: 3980, avatar: '👨', country: '🇺🇸', isUser: false },
  { rank: 5, name: 'Peter', xp: 2340, avatar: '👨‍🎓', country: '🇹🇼', isUser: true }
];
